export default __webpack_public_path__ + "static/media/member.314b2141.svg";